<!-- Esqueleto con la geometría REAL de la franja: al llegar las cifras nada salta de sitio. -->
<div class="cf-strip" *ngIf="loading; else contenido" aria-busy="true" aria-label="Cargando el resumen del mes">
  <div class="cf-tile" *ngFor="let t of [1, 2, 3, 4]">
    <p-skeleton height="0.72rem" width="7.5rem"></p-skeleton>
    <p-skeleton height="1.375rem" width="9rem"></p-skeleton>
    <p-skeleton height="0.75rem" width="100%"></p-skeleton>
  </div>
</div>

<ng-template #contenido>
  <!-- Qué gobierna el selector del encabezado, dicho — y dicho POR VISTA.
       ! La frase era fija: «las tablas de abajo no se filtran por el mes». Es verdad en Dinero y en la
       ! cola de excepciones, y FALSA en las otras cuatro: Comprobantes, CENTRAL, Cartera y Avance
       ! escuchan el mismo selector y cambian con él. Una frase del encabezado que se contradice con lo
       ! que hace la pantalla dos centímetros más abajo le quita valor a todo lo demás que ahí se lea. -->
  <p class="cf-caption" *ngIf="summary">
    El mes en cuatro cifras · <b>{{ monthLabel }}</b
    ><span>{{ tablaSigueElMes ? 'y la tabla de abajo también se filtra por él' : 'lo de abajo no se filtra por el mes' }}</span>
  </p>

  <div class="cf-strip" *ngIf="summary">
    <div class="cf-tile" [class.is-act]="isActive('expected')">
      <div class="cf-lbl">
        Debería entrar
        <!-- La composición de esta cifra no es evidente y es la que Contabilidad contrasta contra su
             hoja. Con el «?» delante, la conversación es sobre la definición y no sobre un bug. -->
        <button type="button" class="cf-help" (click)="ayuda.toggle($event)" aria-label="Qué cuenta como debería entrar">
          <i class="fa-solid fa-circle-question"></i>
        </button>
      </div>
      <div class="cf-val">{{ summary.expected.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</div>
      <div class="cf-sub">
        <b>{{ summary.expected.breakdown.letters.count }}</b>
        {{ summary.expected.breakdown.letters.count === 1 ? 'letra vence' : 'letras vencen' }} este mes
        <!-- El rezago va en su renglón: sumarlo lo contaría dos veces y esconderlo haría falsa la cifra -->
        <span class="cf-arrears" *ngIf="summary.arrears.amount > 0">
          + {{ summary.arrears.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }} vencido de antes
        </span>
      </div>
    </div>

    <div class="cf-tile" [class.is-act]="isActive('received')">
      <div class="cf-lbl">
        Entró
        <!-- «Entró» se lee como «lo que cobramos», y no es exactamente eso: es el dinero REGISTRADO
             con fecha de pago del mes, esté aplicado o no. Sin decirlo, la brecha contra «debería
             entrar» se interpreta como morosidad cuando puede ser captura pendiente. -->
        <button type="button" class="cf-help" (click)="ayudaEntro.toggle($event)" aria-label="Qué cuenta como entró">
          <i class="fa-solid fa-circle-question"></i>
        </button>
      </div>
      <div class="cf-val">{{ summary.received.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</div>
      <div class="cf-sub">
        <ng-container *ngIf="gap > 0"
          >faltan <b>{{ gap | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b> ·
        </ng-container>
        <ng-container *ngIf="overpaid > 0"
          >entró <b>{{ overpaid | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b> de más ·
        </ng-container>
        <b>{{ summary.received.count }}</b> {{ summary.received.count === 1 ? 'pago' : 'pagos' }}
      </div>
    </div>

    <div class="cf-tile" [class.is-act]="isActive('invoiced')">
      <div class="cf-lbl">Facturado</div>
      <div class="cf-val">{{ summary.invoiced.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</div>
      <div class="cf-sub">
        <b>{{ summary.invoiced.count }}</b> CFDI {{ summary.invoiced.count === 1 ? 'emitido' : 'emitidos' }}
      </div>
    </div>

    <div class="cf-tile">
      <div class="cf-lbl">Cobrado de lo facturado</div>
      <div class="cf-val is-good">{{ summary.invoicedCollected.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</div>
      <div class="cf-sub">
        de <b>{{ summary.invoiced.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b> · {{ summary.invoicedCollected.count }} de
        {{ summary.invoiced.count }} cerradas
      </div>
      <!-- Medidor porque es un SUBCONJUNTO de la casilla anterior, no un cuarto sumando -->
      <div class="cf-meter" role="img" [attr.aria-label]="collectedPct + '% de lo facturado del mes ya está cobrado'">
        <i [style.width.%]="collectedPct"></i>
      </div>
    </div>
  </div>
</ng-template>

<!-- Sin X: el círculo oscuro de PrimeNG se sale del panel y no es de esta plataforma. Se cierra
     haciendo clic fuera, que es lo que ya hacía todo el mundo, o con Escape. -->
<p-overlayPanel #ayuda styleClass="cf-help-panel" appendTo="body">
  <div class="cf-help-body">
    <h4>Qué cuenta como «debería entrar»</h4>

    <p class="cf-help-sec">Todo lo exigible del mes, con IVA</p>
    <ul class="cf-comp">
      <li>
        <span class="cf-plus" aria-hidden="true">+</span>
        <b class="cf-comp-t">Rentas del mes</b>
        <span class="cf-comp-amt">{{ summary?.expected?.breakdown?.letters?.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
        <em class="cf-comp-d"
          >Las letras que vencen entre el 1 y el último día. Cada una ya lleva dentro capital, interés, accesorios financiados y su IVA.</em
        >
      </li>
      <li>
        <span class="cf-plus" aria-hidden="true">+</span>
        <b class="cf-comp-t">Mora de esas letras</b>
        <span class="cf-comp-amt">{{ summary?.expected?.breakdown?.mora | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
        <em class="cf-comp-d" *ngIf="summary?.moraEnabled">La exigible al corte del mes, menos la condonada.</em>
        <em class="cf-comp-d" *ngIf="!summary?.moraEnabled"
          >Suma cero porque el interruptor de mora está en pausa — no porque no haya mora.</em
        >
      </li>
      <li>
        <span class="cf-plus" aria-hidden="true">+</span>
        <b class="cf-comp-t">Residuales</b>
        <span class="cf-comp-amt">{{ summary?.expected?.breakdown?.residuals?.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
        <em class="cf-comp-d">Los que vencen en el mes, al cierre del plazo del arrendamiento.</em>
      </li>
      <li>
        <span class="cf-plus" aria-hidden="true">+</span>
        <b class="cf-comp-t">Pagos iniciales</b>
        <span class="cf-comp-amt">{{
          summary?.expected?.breakdown?.downPayments?.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2'
        }}</span>
        <em class="cf-comp-d">Los enganches <strong>facturados</strong> en el mes — no los pactados: los que ya tienen CFDI emitido.</em>
      </li>
    </ul>

    <p class="cf-help-sec">Lo que no entra en la cifra</p>
    <ul class="cf-out">
      <li>
        <i class="fa-solid fa-xmark"></i>
        <span
          ><b>Lo vencido de meses anteriores.</b> Ya contó en su mes; sumarlo aquí lo contaría dos veces y el historial dejaría de cuadrar.
          Va aparte, en el renglón de la casilla.</span
        >
      </li>
      <li>
        <i class="fa-solid fa-xmark"></i>
        <span><b>Los pagos anticipados</b> de meses siguientes. Cuentan en el mes de la letra que cubren.</span>
      </li>
    </ul>

    <p class="cf-help-rule">
      <i class="fa-solid fa-calendar-day"></i>
      <span
        >La fecha que manda es el <b>vencimiento de la letra</b>, no cuándo se registró nada. Para el enganche, la de su factura. Y en
        «Entró», la fecha en que pagó el cliente.</span
      >
    </p>
  </div>
</p-overlayPanel>

<p-overlayPanel #ayudaEntro styleClass="cf-help-panel" appendTo="body">
  <div class="cf-help-body">
    <h4>Qué cuenta como «entró»</h4>

    <p class="cf-help-lead">
      El dinero que <b>llegó y está registrado</b>, con fecha de pago dentro del mes. No es lo que se aplicó: un depósito que sigue sin
      repartirse entre letras <b>ya cuenta aquí</b>.
    </p>

    <ul class="cf-comp">
      <li>
        <span class="cf-plus" aria-hidden="true">+</span>
        <b class="cf-comp-t">Todos los pagos del mes</b>
        <span class="cf-comp-amt">{{ summary?.received?.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</span>
        <em class="cf-comp-d"
          >Por la fecha en que pagó el <strong>cliente</strong>, no por la de captura: un depósito del 30 de agosto capturado el 2 de
          septiembre cuenta en agosto.</em
        >
      </li>
    </ul>

    <p class="cf-help-sec">Lo que no entra en la cifra</p>
    <ul class="cf-out">
      <li>
        <i class="fa-solid fa-xmark"></i>
        <span><b>Los pagos anulados.</b> Un pago fuera de circulación no entró, aunque su registro siga en la bitácora.</span>
      </li>
      <li>
        <i class="fa-solid fa-xmark"></i>
        <span><b>Lo facturado sin cobrar.</b> Eso vive en las otras dos casillas: aquí solo hay dinero recibido.</span>
      </li>
    </ul>

    <p class="cf-help-rule">
      <i class="fa-solid fa-scale-unbalanced"></i>
      <span
        >La diferencia contra «debería entrar» <b>no es morosidad por sí sola</b>: puede ser dinero que todavía no se captura, o cobro
        adelantado de meses siguientes.</span
      >
    </p>
  </div>
</p-overlayPanel>
